import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-8 border p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, " My Employer Contributions Month-by-Month ", -1)
const _hoisted_3 = {
  id: "barChart",
  ref: "chartRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("canvas", _hoisted_3, null, 512)
  ]))
}